import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { MainContext } from "../../../MainContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { request } from "../../../request";
import Swal from "sweetalert2";
import "./CustomerList.scss";
import { ToastToggle } from "flowbite-react";
import MovingIcon from "@mui/icons-material/Moving";

const CustomersList = ({ customers, darkMode, setEdit, texts, updateCustomers }) => {
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const { openState, boxOpener } = useContext(MainContext);

    const options = customers.map((customer) => ({
        value: customer._id,
        label: customer.name,
    }));

    useEffect(() => {
        if (selectedCustomer) {
            setFilteredCustomers(customers.filter((customer) => customer.name === selectedCustomer.label));
        } else {
            setFilteredCustomers(customers);
        }
    }, [selectedCustomer, customers]);

    const handleEdit = (id) => {
        window.scrollTo(0, 0);
        setEdit(id);
    };

    const handleDeactivate = async (id) => {
        try {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to deactivate this customer",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await request.post("/customer/deactivate", {
                        customerId: id,
                    });
                    Swal.fire({ title: "Customer deactivated successfully", icon: "success" });
                }
            });
        } catch (error) {}
    };

    const handleActivate = async (id) => {
        try {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to activate this customer",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await request.post("/customer/deactivate", {
                        customerId: id,
                    });
                    Swal.fire({ title: "Customer activated successfully", icon: "success" });
                }
            });
        } catch (error) {}
    };

    return (
        <div style={{ overflow: "scroll" }} class="flex flex-1 sm:justify-center py-5">
            <div class="layout-content-container flex flex-col max-w-[960px] flex-1">
                <h2 class="text-[#111418] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5" style={{ color: darkMode ? "white" : "black" }}>
                    {texts.customer.customers}
                </h2>
                <div class="px-4 py-3">
                    <label class="flex flex-col min-w-40 h-12 w-full">
                        <div class="wp-full max-w-[960px] mb-10 px-15">
                            <Select
                                placeholder={texts.customer.searchCustomersByName}
                                options={options}
                                isClearable
                                value={selectedCustomer}
                                onChange={(selectedCustomer) => {
                                    setSelectedCustomer(selectedCustomer);
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: "gray",
                                        borderRadius: "0.375rem",
                                        padding: "0.375rem",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "blue" },
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? "#FEC901" : state.isFocused ? "lightgray" : "white",
                                        color: state.isSelected ? "black" : "black",
                                        "&:hover": {
                                            backgroundColor: "lightblue",
                                        },
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        marginTop: 0,
                                        borderRadius: "0.375rem",
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        color: "gray",
                                        fontSize: "0.875rem",
                                    }),
                                }}
                            />
                        </div>
                    </label>
                </div>
                <div class="px-4 py-3 @container">
                    <div
                        class="flex overflow-hidden rounded-xl border border-[#dce0e5]"
                        style={{
                            backgroundColor: darkMode ? "#141619" : "white",
                        }}
                    >
                        <table class="flex-1">
                            <thead>
                                <tr
                                    class="bg-white"
                                    style={{
                                        backgroundColor: darkMode ? "#141619" : "white",
                                    }}
                                >
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-120 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.name}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-240 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.contact}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.comment}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.customerType}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.action}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCustomers
                                    .filter((c) => !c.deactivated)
                                    .map((customer) => (
                                        <tr className={`table-row ${customer.deactivated ? "deactivated" : ""}`}>
                                            <td className="table-cell" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.name}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.contact}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.comment}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.type}
                                            </td>
                                            <td className="table-cell actions">
                                                {customer.deactivated ? (
                                                    <>
                                                        <Tooltip title="Acitvate">
                                                            <IconButton onClick={() => handleActivate(customer._id)}>
                                                                <MovingIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Tooltip title="Edit">
                                                            <IconButton onClick={() => handleEdit(customer._id)}>
                                                                <EditIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Deactivate">
                                                            <IconButton onClick={() => handleDeactivate(customer._id)}>
                                                                <DeleteIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <h1 style={{ color: "white", margin: "20px" }}>Deactivated customers</h1>

                <div class="px-4 py-3 @container">
                    <div
                        class="flex overflow-hidden rounded-xl border border-[#dce0e5]"
                        style={{
                            backgroundColor: darkMode ? "#141619" : "white",
                        }}
                    >
                        <table class="flex-1">
                            <thead>
                                <tr
                                    class="bg-white"
                                    style={{
                                        backgroundColor: darkMode ? "#141619" : "white",
                                    }}
                                >
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-120 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.name}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-240 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.contact}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.comment}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.customerType}
                                    </th>
                                    <th
                                        class="table-a41ee2e5-82da-4672-b3f7-d3bb9f1b04ef-column-360 px-4 py-3 text-left text-[#111418] w-[400px] text-sm font-medium leading-normal"
                                        style={{
                                            color: darkMode ? "white" : "black",
                                        }}
                                    >
                                        {texts.customer.action}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCustomers
                                    .filter((c) => c.deactivated)
                                    .map((customer) => (
                                        <tr className={`table-row ${customer.deactivated ? "deactivated" : ""}`}>
                                            <td className="table-cell" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.name}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.contact}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.comment}
                                            </td>
                                            <td className="table-cell secondary" style={{ color: darkMode ? "white" : "black" }}>
                                                {customer.type}
                                            </td>
                                            <td className="table-cell actions">
                                                {customer.deactivated ? (
                                                    <>
                                                        <Tooltip title="Acitvate">
                                                            <IconButton onClick={() => handleActivate(customer._id)}>
                                                                <MovingIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Tooltip title="Edit">
                                                            <IconButton onClick={() => handleEdit(customer._id)}>
                                                                <EditIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Deactivate">
                                                            <IconButton onClick={() => handleDeactivate(customer._id)}>
                                                                <DeleteIcon sx={{ color: "white" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomersList;
